import request from '../request'

// 查询单个项目要求确认及会签评审
export function fetchDetail(data) {
    return request({
        url: `/project-service/cosys/prj/review/detail/${data.id}`,
        method: 'get',
    })
}

// 重新提交会签评审
export function resubmitPrjReview(data) {
    return request({
        url: '/project-service/cosys/prj/review/resubmit',
        method: 'post',
        data
    })
}


export function getPersonnel(orgId) {
    return request({
        url: '/user-service/org/getPersonnel',
        params: { orgId },
        method: 'GET'
    })
}

export function getCompanyPersonnel(orgId) {
    return request({
        url: '/user-service/org/getCompanyPersonnel',
        params: { orgId },
        method: 'GET'
    })
}
